import React from "react";

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16 text-zinc-300" data-testid="privacy-page">
      <span className="label-overline">// Legal</span>
      <h1 className="font-display text-5xl tracking-widest leading-none mt-3 mb-10">Privacy Policy</h1>

      <p className="text-sm text-zinc-500 mb-8">Last updated: February 2026</p>

      <div className="space-y-6 text-sm leading-relaxed">
        <p>
          Train With Lucy ("we", "us") respects your privacy. This policy explains what we collect, why, and how we use it when you use trainwithlucy (the "Service").
        </p>

        <h2 className="font-display text-2xl tracking-wider text-white pt-4">What we collect</h2>
        <ul className="list-disc list-outside pl-5 space-y-2">
          <li><span className="text-white">Account info</span> — your name, email, and password (stored securely as a one-way hash).</li>
          <li><span className="text-white">Purchase records</span> — which classes you bought, your subscription status, and PayPal transaction IDs (we never see or store your full card details).</li>
          <li><span className="text-white">Basic usage data</span> — anonymous traffic stats so we can improve the Service.</li>
        </ul>

        <h2 className="font-display text-2xl tracking-wider text-white pt-4">How we use it</h2>
        <ul className="list-disc list-outside pl-5 space-y-2">
          <li>To deliver the classes you've purchased and unlock content for active subscribers.</li>
          <li>To process payments via PayPal.</li>
          <li>To contact you about your account, purchases, or important Service changes.</li>
          <li>We do <span className="text-white">not</span> sell your data, ever.</li>
        </ul>

        <h2 className="font-display text-2xl tracking-wider text-white pt-4">Third parties</h2>
        <p>
          We use <span className="text-white">PayPal</span> to process payments — your payment data is handled directly by PayPal under their privacy policy. Videos and thumbnails are stored on secure cloud object storage.
        </p>

        <h2 className="font-display text-2xl tracking-wider text-white pt-4">Your rights</h2>
        <p>
          You can request a copy of, correction to, or deletion of your data at any time by emailing the address below. Cancel your subscription anytime from the Subscribe page.
        </p>

        <h2 className="font-display text-2xl tracking-wider text-white pt-4">Cookies</h2>
        <p>
          We use a single token stored in your browser's localStorage to keep you logged in. We do not use third-party advertising cookies.
        </p>

        <h2 className="font-display text-2xl tracking-wider text-white pt-4">Contact</h2>
        <p>
          Questions? Email <a className="text-[#D4A574] hover:underline" href="mailto:hello@trainwithlucy.app">hello@trainwithlucy.app</a>.
        </p>
      </div>
    </div>
  );
}
